module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-wallet-components/src/fi-logos/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/fi-logos/template.html
// module chunks = 1